import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { FileTextOutlined } from '@ant-design/icons-vue';
import layoutSiderbar from '@/views/layout/siderbar/siderbar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();

// 是否处于 biz 页面模式（index.html?cls=xxx）
const isBizMode = computed(() => {
  const p = route.path;
  return p === '/index.html' || p?.endsWith('/index.html');
});


const __returned__ = { route, isBizMode, get FileTextOutlined() { return FileTextOutlined }, layoutSiderbar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})